import {
  GET_COORDINATOR_UNIQUE_LINK_COUNT_URL,
  GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_URL,
} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {
  GET_COORDINATOR_UNIQUE_LINK_COUNT_QUERY_KEY,
  GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_QUERY_KEY,
} from '../../constants/queryKeys';
import {Coordinator, GenericExamLevel} from '../../api/candidate/exam/model';

interface Input {
  orgUuid: string;
  examLevel?: GenericExamLevel;
}

export interface CoordinatorUniqueLinkCountResponse {
  coordinator: Coordinator;
  uniqueLinkCount: number;
}

export const useGetCoordinatorUniqueLinkCount = ({orgUuid, examLevel}: Input) => {
  const getCoordinatorUniqueLinkCount = async () => {
    const res = await axiosClient.get<CoordinatorUniqueLinkCountResponse[]>(
        GET_COORDINATOR_UNIQUE_LINK_COUNT_URL(orgUuid, examLevel)
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_COORDINATOR_UNIQUE_LINK_COUNT_QUERY_KEY, orgUuid, examLevel],
      getCoordinatorUniqueLinkCount,
      {
        enabled: !!orgUuid && examLevel !== undefined,
      }
  );
};

export const useGetCoordinatorWithdrawalUniqueLinkCount = ({orgUuid, examLevel}: Input) => {
  const getCoordinatorUniqueLinkCount = async () => {
    const res = await axiosClient.get<CoordinatorUniqueLinkCountResponse[]>(
        GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_URL(orgUuid, examLevel)
    );
    return res.data;
  };

  return useCustomQuery(
      [GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_QUERY_KEY, orgUuid, examLevel],
      getCoordinatorUniqueLinkCount,
      {
        enabled: !!orgUuid && examLevel !== undefined,
      }
  );
};
